import React from "react";
import Reveal from "../components/Reveal";

const sections = [
  { h: "Acceptance of Terms", p: "By accessing Recovery Leaders, you agree to these Terms of Service. If you do not agree, please do not use this website." },
  { h: "Educational Resource Only", p: "Recovery Leaders is an educational resource. Nothing on this website constitutes legal, financial, or investment advice. You should consult qualified professionals before making decisions." },
  { h: "No Guarantee of Recovery", p: "We do not and cannot guarantee the recovery of any funds. Any case patterns or outcomes shared are illustrative and anonymized. Past results do not guarantee future outcomes." },
  { h: "No Upfront Fees for Consultations", p: "Our initial consultations are free and confidential. We will never pressure you into paid services or charge upfront fees for a consultation." },
  { h: "Beware of Recovery Scams", p: "Legitimate services never guarantee results or demand advance fees to release 'frozen' funds. Always verify any organization independently." },
  { h: "Limitation of Liability", p: "Recovery Leaders is not liable for any losses arising from your use of this website or reliance on its educational content." },
  { h: "Contact", p: "Questions about these terms can be sent to support@recovery-leaders.com." },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <section className="hero-mesh section">
        <div className="container max-w-3xl">
          <Reveal>
            <h1 className="mb-4 font-display text-4xl font-extrabold tracking-tight text-primary md:text-5xl">Terms of Service</h1>
            <p className="text-muted-foreground">Please read these terms carefully. Last updated {new Date().getFullYear()}.</p>
          </Reveal>
        </div>
      </section>
      <section className="section">
        <div className="container max-w-3xl space-y-8">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.04}>
              <div>
                <h2 className="mb-2 font-display text-xl font-semibold">{s.h}</h2>
                <p className="text-muted-foreground">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
